import { Pipe } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { I18nService } from '../../services/i18n.service';

@Pipe({
  name: 'currencyLocalized',
  pure: false // make pipe trigger on every change detection tick
})
export class CurrencyLocalizedPipe extends CurrencyPipe {

  constructor(
    private _i18nService: I18nService
  ) {
    super(_i18nService.defaultLanguage);
  }

  transform(
    value: null | undefined,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string): null;
  transform(
    value: number | string | null | undefined,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string): string | null;
  transform(
    value: number | string,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string,
  ): string | null {
    if (['CNY', 'THB', 'MYR', 'IDR', 'PHP', 'MXN', 'ARS'].includes(currencyCode ?? '')) {
      display = 'symbol-narrow';
    }

    if (currencyCode === 'BHD') {
      currencyCode = 'BD';
    }

    if (currencyCode === 'COP') {
      currencyCode = 'COL$';
    }

    return super.transform(value, currencyCode, display, digitsInfo, this._i18nService.language);
  }
}
